export default function clickOutside(node: HTMLElement) {
	const handleClick = (event: MouseEvent) => {
		if (
			node &&
			!node.contains(event.target as HTMLElement) &&
			!event.defaultPrevented
		) {
			node.dispatchEvent(
				new CustomEvent("click-outside", {
					detail: {
						node,
						target: event.target,
						originalEvent: event,
					},
				}),
			)
		}
	}

	document.addEventListener("click", handleClick, true)

	return {
		destroy() {
			document.removeEventListener("click", handleClick, true)
		},
	}
}
